import { parseContent } from 'api/base';

export const widgetsEnum = {
	'PRODUCT-TWOCOLUMN': 'ProductCardsWidget',
	'OPTION-TWOCOLUMN': 'ProductOptionCardsWidget',
	'OPTION-TWOCOLUMN~SHORT-DESCRIPTION': 'ProductOptionCardsWidget',
	'OPTION-TWOCOLUMN~FULL-DESCRIPTION': 'ProductOptionCardsWidget',
	'PRODUCT-DETAILED-TWOCOLUMN': 'ProductDetailedCardWidget',
	'PRODUCT-DETAILED-TWOCOLUMN~SHORT-DESCRIPTION': 'ProductDetailedCardWidget',
	'PRODUCT-DETAILED-TWOCOLUMN~FULL-DESCRIPTION': 'ProductDetailedCardWidget',
	'CONTACT-FORM-FROM-COMPANY-DETAILS': 'ContactFormFromCompanyDetailsWidget',
	'CONTACT-FORM-FROM-COMPANY-DETAILS~TOKEN': 'ContactFormFromCompanyDetailsWidget',
	'CONTACT-DETAILS-FROM-COMPANY-DETAILS': 'ContactDetailsFromCompanyDetailsWidget',
	'CONTACT-DETAILS-FROM-COMPANY-DETAILS~TOKEN': 'ContactDetailsFromCompanyDetailsWidget',
	'TC-DETAILS-FROM-COMPANY-DETAILS': 'TCDetailsFromCompanyDetails',
	'TC-DETAILS-FROM-COMPANY-DETAILS~TOKEN': 'TCDetailsFromCompanyDetails',
	'DISCLOSURE-DETAILS-FROM-COMPANY-DETAILS': 'DisclosureDetailsFromCompanyDetailsWidget',
	'DISCLOSURE-DETAILS-FROM-COMPANY-DETAILS~TOKEN': 'DisclosureDetailsFromCompanyDetailsWidget',
	'OPTION-ONECOLUMN': 'ProductOptionCardsWidget',
	'OPTION-ONECOLUMN~SHORT-DESCRIPTION': 'ProductOptionCardsWidget',
	'OPTION-ONECOLUMN~FULL-DESCRIPTION': 'ProductOptionCardsWidget',
	'PRODUCT-DETAILED-ONECOLUMN': 'ProductDetailedCardWidget',
	'PRODUCT-DETAILED-ONECOLUMN~SHORT-DESCRIPTION': 'ProductDetailedCardWidget',
	'PRODUCT-DETAILED-ONECOLUMN~FULL-DESCRIPTION': 'ProductDetailedCardWidget'
};

const getTextAfterTilde = rawText => {
	let textAfterTilde;
	const splitRawText = rawText?.split('~');
	if (splitRawText?.length) {
		textAfterTilde = splitRawText;
	}
	return textAfterTilde;
};

const getCols = name => {
	const splittedName = name?.split('~');
	const baseColl = splittedName.find(_key => _key?.startsWith('COL'));
	let columnNumbersArray = baseColl?.match(/\d+/g);
	return columnNumbersArray ? Number(columnNumbersArray[0]) : undefined;
};

const generateWidgetColsEnums = (option, columnCount, type) => {
	if (option.includes('CONTACT')) {
		return Array.from({ length: columnCount * 2 }, (_, index) => {
			const colNumber = Math.ceil((index + 1) / 2);
			const descriptionType = index % 2 === 0 ? 'FORM-FROM-COMPANY-DETAILS' : 'DETAILS-FROM-COMPANY-DETAILS';
			return `${option}-${descriptionType}~COL-${colNumber}`;
		});
	}

	return Array.from({ length: columnCount * 2 }, (_, index) => {
		const colNumber = Math.ceil((index + 1) / 2);
		const descriptionType = index % 2 === 0 ? 'SHORT-DESCRIPTION' : 'FULL-DESCRIPTION';
		return `${option}~${descriptionType}~COL-${colNumber}`;
	});
};

const createWidgetObject = ({ name, witem, widgetEnum }) => {
	const splittedName = getTextAfterTilde(name);
	return {
		name: splittedName?.[0] ?? name,
		widget: widgetEnum || widgetsEnum[name],
		description: witem.localName,
		language: '',
		content: witem.innerHTML,
		isWidget: true,
		type: splittedName?.[1],
		columnType: name?.includes('ONECOLUMN') ? 'ONE' : 'TWO',
		columns: getCols(name)
	};
};

function matchWidget(widgets) {
	let widgetData = [];

	const store = require('app/store').default;
	const state = store?.getState();
	const wlData = state?.fuse?.form?.channelSettings?.value;
	Array.prototype.forEach.call(widgets, witem => {
		if (wlData?.channelWidgets?.length > 0) {
			wlData?.channelWidgets?.forEach(function (item, index) {
				let rawName = witem.innerHTML.replace('[[[', '').replace(']]]', '');
				if (item.name === rawName) {
					let contents = {};
					Array.prototype.forEach.call(item.contents, citem => {
						contents[citem.key] = citem.value;
					});
					widgetData.push({
						name: item.name,
						widget: widgetsEnum[item.channelWidgetTemplate.name],
						description: item.description,
						language: item.language,
						content: contents,
						isWidget: true
					});
				} else if (Object.keys(widgetsEnum).includes(rawName)) {
					widgetData.push(
						createWidgetObject({
							name: rawName,
							witem
						})
					);
				} else if (
					generateWidgetColsEnums('OPTION-ONECOLUMN', 12).includes(rawName) ||
					generateWidgetColsEnums('OPTION-TWOCOLUMN', 12).includes(rawName)
				) {
					widgetData.push(
						createWidgetObject({
							name: rawName,
							witem,
							widgetEnum: 'ProductOptionCardsWidget'
						})
					);
				} else if (
					generateWidgetColsEnums('PRODUCT-DETAILED-ONECOLUMN', 12).includes(rawName) ||
					generateWidgetColsEnums('PRODUCT-DETAILED-TWOCOLUMN', 12).includes(rawName)
				) {
					widgetData.push(
						createWidgetObject({
							name: rawName,
							witem,
							widgetEnum: 'ProductDetailedCardWidget'
						})
					);
				} else if (generateWidgetColsEnums('CONTACT', 12).includes(rawName)) {
					widgetData.push(
						createWidgetObject({
							name: rawName,
							witem,
							widgetEnum: rawName.includes('CONTACT-FORM')
								? 'ContactFormFromCompanyDetailsWidget'
								: 'ContactDetailsFromCompanyDetailsWidget'
						})
					);
				} else {
					widgetData.push({
						name: witem.localName === 'p' ? 'paragraph' : 'header',
						widget: witem.localName === 'p' ? 'paragraph' : 'header',
						description: witem.localName,
						language: '',
						content: witem.innerHTML,
						isWidget: false
					});
				}
			});
		} else {
			let rawName = witem.innerHTML.replace('[[[', '').replace(']]]', '');
			if (Object.keys(widgetsEnum).includes(rawName)) {
				widgetData.push(
					createWidgetObject({
						name: rawName,
						witem
					})
				);
			} else if (
				generateWidgetColsEnums('OPTION-ONECOLUMN', 12).includes(rawName) ||
				generateWidgetColsEnums('OPTION-TWOCOLUMN', 12).includes(rawName)
			) {
				widgetData.push(
					createWidgetObject({
						name: rawName,
						witem,
						widgetEnum: 'ProductOptionCardsWidget'
					})
				);
			} else if (
				generateWidgetColsEnums('PRODUCT-DETAILED-ONECOLUMN', 12).includes(rawName) ||
				generateWidgetColsEnums('PRODUCT-DETAILED-TWOCOLUMN', 12).includes(rawName)
			) {
				widgetData.push(
					createWidgetObject({
						name: rawName,
						witem,
						widgetEnum: 'ProductDetailedCardWidget'
					})
				);
			} else if (generateWidgetColsEnums('CONTACT', 12).includes(rawName)) {
				widgetData.push(
					createWidgetObject({
						name: rawName,
						witem,
						widgetEnum: rawName.includes('CONTACT-FORM')
							? 'ContactFormFromCompanyDetailsWidget'
							: 'ContactDetailsFromCompanyDetailsWidget'
					})
				);
			} else {
				widgetData.push({
					name: witem.localName === 'p' ? 'paragraph' : 'header',
					widget: witem.localName === 'p' ? 'paragraph' : 'header',
					description: witem.localName,
					language: '',
					content: witem.outerHTML,
					isWidget: false
				});
			}
		}
	});

	return widgetData;
}

export function getPage(page, productId) {
	const store = require('app/store').default;
	const state = store?.getState();
	const wlData = state?.fuse?.form?.channelSettings?.value;

	if (!wlData?.channelPages) return { url: '', content: [] };

	let pageData = { url: '', content: [] };

	for (const item of wlData.channelPages) {
		if (item.pageLink === page) {
			if (item.linkedProduct) {
				const matchedPage = wlData.channelPages.find(p => p.linkedProduct === productId);
				if (matchedPage?.htmlContent) {
					pageData.url = item.pageLink;
					pageData.content = matchWidget(parseContent(matchedPage.htmlContent)?.body?.children || []);
					return pageData;
				}
			} else {
				if (item.htmlContent) {
					pageData.url = item.pageLink;
					pageData.content = matchWidget(parseContent(item.htmlContent)?.body?.children || []);
				}
			}
		}
	}

	return pageData;
}
